import { render, staticRenderFns } from "./searchAllData.vue?vue&type=template&id=9bffc3b4&scoped=true"
import script from "./searchAllData.vue?vue&type=script&lang=js"
export * from "./searchAllData.vue?vue&type=script&lang=js"
import style0 from "./searchAllData.vue?vue&type=style&index=0&id=9bffc3b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bffc3b4",
  null
  
)

export default component.exports